import React from 'react';
import App from './App';
// import { Web3ReactProvider } from "@web3-react/core";
import { Provider } from "react-redux";
import { createRoot } from 'react-dom/client'
import { hooks as walletConnectV2Hooks, walletConnectV2 } from './connectors/walletConnectV2.js'
import { hooks as metaMaskHooks, metaMask } from './connectors/metaMask'
import { hooks as coinbaseWalletHooks, coinbaseWallet } from './connectors/coinbaseWallet';
import store from './redux/store/store.js';
import useEagerConnect from './hooks/useEagerConnect.js';
import './i18n';
import { RecoilRoot } from 'recoil';
import { ThemeProvider } from './contexts/ThemeProvider.js';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { config } from './config/wagmi.js';

const Web3Wrapper = ({ children }) => {
  useEagerConnect();
  return children;
};

const connectors = [
  [walletConnectV2, walletConnectV2Hooks],
  [metaMask, metaMaskHooks],
  [coinbaseWallet, coinbaseWalletHooks],
];

const queryClient = new QueryClient();

const domNode = document.getElementById('root');
const root = createRoot(domNode);

root.render(
  <WagmiProvider config={config}>
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </RecoilRoot>
    </QueryClientProvider>
  </Provider>
</WagmiProvider>


);